import { AxiosResponse, InternalAxiosRequestConfig } from "axios";

import { API_URL, ENDPOINTS, JWT_KEY } from "./constants/api";
import { triggerLoading } from "./utils/loadingManager";
import { User } from "./common/model/User";

// Extend axios config to support skipLoading
declare module 'axios' {
    interface AxiosRequestConfig {
        skipLoading?: boolean;
    }
}

const Config = {
    BACKEND_URL: API_URL,

    getAxiosConfig: () => {
        return {
            baseURL: Config.BACKEND_URL,
            headers: {
                "Content-Type": "application/json",
            },
            interceptors: {
                request: (config: InternalAxiosRequestConfig<any>) => {
                    const userJson = localStorage.getItem(JWT_KEY);
                    const user: User | null = userJson ? JSON.parse(userJson) : null;

                    const PUBLIC_ENDPOINTS = [ENDPOINTS.AUTH.LOGIN];
                    // Extract the path without query params for comparison
                    const urlPath = config.url?.split("?")[0];
                    const isPublicEndpoint = PUBLIC_ENDPOINTS.some((path) => urlPath === path);

                    if (user && user.accesstoken && !isPublicEndpoint && config.headers) {
                        config.headers.Authorization = `Bearer ${user.accesstoken}`;
                    }

                    // Only trigger loading if skipLoading is not set
                    if (!config.skipLoading) {
                        triggerLoading(true);
                    }
                    return config;
                },
                response: (response: AxiosResponse) => {
                    // Only trigger loading if skipLoading was not set
                    if (!response.config.skipLoading) {
                        triggerLoading(false);
                    }
                    return response;
                },
                error: (error: any) => {
                    // Only trigger loading if skipLoading was not set
                    if (!error.config?.skipLoading) {
                        triggerLoading(false);
                    }
                    return Promise.reject(error);
                },
            },
        };
    },
};

export default Config;
